import React from 'react';
import i18n from '../../../../utils/ChrI18n';

const bufferHeight = 40;
const minCalendarHeight = 400;

export const getHeaderToolbar = {
  left: '',
  center:'prev,title,next',
  right: 'today'
};

export const headerToolbarButtonsText = {
  today: i18n.t("chronus_date_range_picker_strings.preset_ranges.today")
}

export const getTitleFormat = dateInfo => {
  return `${ fullCalendarTranslations.monthNames[dateInfo.start.month] } ${ dateInfo.start.year }`;
};

export const getDayHeaderContent = date => {
  return fullCalendarTranslations.dayNamesShort[date.dow];
};

export const getDayPopoverFormat = dateInfo => {
  return `${ fullCalendarTranslations.monthNames[dateInfo.start.month] } ${ dateInfo.start.day }, ${ dateInfo.start.year }`;
};

export const toggleLoader = () => {
  document.querySelector(".calendar-backdrop").classList.toggle("hide");
};

export const renderMoreLink = clickInfo => {
  return (
    <div className="p-2 font-12 text-muted font-600 cui-fc-daygrid-more-link">
      +{ clickInfo.num } { i18n.t('display_string.more') }
    </div>
  );
};

export const handleCalendarMount = (containerRef, todayButtonTooltip) => {
  containerRef.current.querySelector(".fc-prev-button").setAttribute(
    "title",
    i18n.t("feature.full_calendar.content.previous_month")
  );
  containerRef.current.querySelector(".fc-next-button").setAttribute(
    "title",
    i18n.t("feature.full_calendar.content.next_month")
  );
  containerRef.current.querySelector('.fc-today-button').setAttribute(
    'title',
    todayButtonTooltip
  );
  setKeyboardAccessible(containerRef.current.querySelector('.fc-toolbar-title'));
  setKeyboardAccessible(containerRef.current.querySelector('.fc-today-button'));
};

export const handleEventMount = containerRef => {
  const popover = containerRef.current.querySelector('.fc-popover');
  if(popover) {
    const closeButton = popover.querySelector('.fc-popover-close');
    closeButton.setAttribute('title', i18n.t("display_string.Close"));
    setKeyboardAccessible(closeButton);
  }

  setTimeout(() => {
    containerRef.current.querySelectorAll('.fc-daygrid-more-link.fc-more-link').forEach(element => {
      element.removeAttribute('title');
    });

    containerRef.current.querySelectorAll("a[aria-expanded]").forEach(element => {
      element.removeAttribute('aria-expanded');
    });
  }, 1); // Adding 1ms delay for the more button to render.
};

export const setCalendarElementHeight = (calendarRef, containerRef) => {
  const viewHarness = containerRef.current.querySelector('.cui-full-calendar-pane-react .fc-view-harness');
  const wrapperElement = document.querySelector('.wrapper.wrapper-content');
  const reactWrapperElement = document.querySelector('.cui-react-wrapper-content');
  const calendarHeight = Math.max(
    window.innerHeight - getElementHeight(document.querySelector('#chronus_header')) -
      getElementHeight(document.querySelector('.cjs-erg-layout-tabs-container')) -
      getElementHeight(document.querySelector('#cjs-erg-layout-back-link-container')) -
      getElementHeight(containerRef.current.querySelector('.fc-header-toolbar')) -
      getElementPaddingBottom(wrapperElement) -
      getElementPaddingBottom(reactWrapperElement) -
      getElementPaddingBottom(containerRef.current) -
      bufferHeight,
    minCalendarHeight
  );

  // TODO: The calendar height is set only when updateSize() is called twice
  viewHarness.style.height = calendarHeight + 'px';
  calendarRef.current.getApi().updateSize();
  viewHarness.style.height = calendarHeight + 'px';
  calendarRef.current.getApi().updateSize();
};

// Private

const setKeyboardAccessible = element => {
  element.setAttribute('tabindex', '0');
  element.addEventListener('keydown', event => {
    if(event.key === ' ') event.target.click();
  })
};

const getElementHeight = element => {
  return element?.offsetHeight || 0
};

const getElementPaddingBottom = element => {
  if(element)
    return parseInt(window.getComputedStyle(element).paddingBottom, 10);
  return 0;
}